import corePackageJson from '../package.json'

export const VERSION = corePackageJson.version
